import * as React from "react";
import styled, { css } from "styled-components";
import { Button, Label } from "components/bootstrap";
import copyToClipboard from "util/copyToClipboard";
import detectPiiSuspect from "logic/telemetry/debug/piiHeuristics";
const ClickableCell = styled.td`
  cursor: pointer;
`;
const TimeCell = styled.td(
  ({ theme }) => css`
    font-family: ${theme.fonts.family.monospace};
    font-size: ${theme.fonts.size.small};
    white-space: nowrap;
  `
);
const PayloadBlock = styled.div(
  ({ theme }) => css`
    font-family: ${theme.fonts.family.monospace};
    font-size: ${theme.fonts.size.small};
    background: ${theme.colors.global.contentBackground};
    border: 1px solid ${theme.colors.cards.border};
    border-radius: ${theme.spacings.xs};
    padding: ${theme.spacings.sm};
    margin: ${theme.spacings.xs} 0;
    white-space: pre-wrap;
    word-break: break-all;
  `
);
const SuspectValue = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.variant.danger};
    font-weight: bold;
  `
);
const STATUS_STYLE = {
  sent: "success",
  suppressed: "warning",
  disabled: "default"
};
const formatTime = (timestamp) => new Date(timestamp).toISOString().slice(11, 23);
const PayloadLine = ({ property, value }) => {
  const suspect = detectPiiSuspect(value);
  const rendered = JSON.stringify(value);
  return /* @__PURE__ */ React.createElement("div", null, '"', property, '":', " ", suspect ? /* @__PURE__ */ React.createElement(SuspectValue, { title: `PII suspect: ${suspect}` }, rendered) : rendered);
};
const TelemetryDebugEntryRow = ({ entry, deltaMs, expanded, onToggle }) => {
  const appActionValue = entry.payload.app_action_value;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement(TimeCell, null, formatTime(entry.timestamp), deltaMs !== null && ` (+${deltaMs}ms)`), /* @__PURE__ */ React.createElement(ClickableCell, { onClick: onToggle }, entry.eventType), /* @__PURE__ */ React.createElement("td", null, appActionValue), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(Label, { bsStyle: STATUS_STYLE[entry.status], bsSize: "xs" }, entry.status))), expanded && /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { colSpan: 4 }, /* @__PURE__ */ React.createElement(PayloadBlock, null, Object.entries(entry.payload).map(([property, value]) => /* @__PURE__ */ React.createElement(PayloadLine, { key: property, property, value }))), /* @__PURE__ */ React.createElement(
    Button,
    {
      bsSize: "xsmall",
      onClick: () => copyToClipboard(
        JSON.stringify(
          { eventType: entry.eventType, timestamp: entry.timestamp, status: entry.status, ...entry.payload },
          null,
          2
        )
      )
    },
    "Copy event as JSON"
  ))));
};
export default TelemetryDebugEntryRow;
